// Layer grandine v2 — celle di probabilità grandine dal radar DPC (prodotto POH,
// endpoint /v1/maps/hail). Pipeline SEPARATA dal motore Weather Sicily Now:
// il POH non passa da ws_rain_products, è un layer di sola visualizzazione.
// GeoJSON source + circle layer, colore per probabilità (%). Refresh 2.5'.
// Sta SOTTO i simboli stazione ('ws-stations-symbols') come gli altri layer.

const API_BASE = (window.WEATHERSICILY_API_BASE || 'https://api.weathersicily.it/v1').replace(/\/+$/, '');
const REFRESH_MS = 150 * 1000;           // ~5' il ciclo POH, rinfresco a 2.5'
const SRC = 'ws-hail-src';
const LYR = 'ws-hail-circles';
const EMPTY = { type: 'FeatureCollection', features: [] };

const state = { map: null, enabled: false, timer: null, popup: null, wired: false };

async function fetchHail() {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 9000);
    try {
        const res = await fetch(API_BASE + '/maps/hail', { cache: 'no-store', credentials: 'omit', signal: ctrl.signal });
        const json = await res.json();
        if (!res.ok || json.success === false) throw new Error('API ' + res.status);
        return json.data || json;
    } finally {
        clearTimeout(timer);
    }
}

function onClick(e) {
    const feature = e.features && e.features[0];
    if (!feature) return;
    const props = feature.properties || {};
    const prob = Number(props.hail_probability);
    const label = {
        very_likely: 'molto probabile', likely: 'probabile',
        possible: 'possibile', low: 'bassa',
    }[props.hail_class] || '';
    const html = '<div class="ws-hail-popup"><b>🧊 Grandine (radar)</b><br>'
        + 'Probabilità: <b>' + (Number.isFinite(prob) ? prob.toFixed(0) + '%' : 'n.d.') + '</b>'
        + (label ? ' — ' + label : '')
        + '<br><small>Radar DPC · prodotto POH · stima, non certezza</small></div>';
    if (state.popup) state.popup.remove();
    state.popup = new maplibregl.Popup({ closeButton: true, maxWidth: '240px' })
        .setLngLat(e.lngLat).setHTML(html).addTo(state.map);
}

function ensureLayer() {
    const map = state.map;
    if (!map.getSource(SRC)) {
        map.addSource(SRC, { type: 'geojson', data: EMPTY });
    }
    if (!map.getLayer(LYR)) {
        const beforeId = map.getLayer('ws-stations-symbols') ? 'ws-stations-symbols' : undefined;
        map.addLayer({
            id: LYR,
            type: 'circle',
            source: SRC,
            paint: {
                'circle-radius': ['interpolate', ['linear'], ['zoom'], 5, 5, 9, 11, 12, 18],
                // soglie in % (hail_probability): 20-50 giallo, 50-80 arancio, >=80 rosso
                'circle-color': ['step', ['coalesce', ['to-number', ['get', 'hail_probability']], 0],
                    '#ffd24d', 50, '#ff8c1a', 80, '#e03131'],
                'circle-opacity': 0.82,
                'circle-stroke-width': 1.4,
                'circle-stroke-color': '#6b1414',
            },
        }, beforeId);
    }
    if (!state.wired) {
        map.on('click', LYR, onClick);
        map.on('mouseenter', LYR, () => { map.getCanvas().style.cursor = 'pointer'; });
        map.on('mouseleave', LYR, () => { map.getCanvas().style.cursor = ''; });
        state.wired = true;
    }
}

async function refresh() {
    if (!state.enabled || !state.map) return;
    try {
        const data = await fetchHail();
        const src = state.map.getSource(SRC);
        if (src) src.setData(data && data.type === 'FeatureCollection' ? data : EMPTY);
    } catch (_) {
        /* silenzioso: rete o frame assente → resta l'ultimo buono */
    }
}

export function initHail(map) {
    state.map = map;
}

export function setHailEnabled(on) {
    if (!state.map) return;
    state.enabled = !!on;
    if (state.enabled) {
        ensureLayer();
        refresh();
        clearInterval(state.timer);
        state.timer = setInterval(() => { if (!document.hidden) refresh(); }, REFRESH_MS);
        if (state.map.getLayer(LYR)) state.map.setLayoutProperty(LYR, 'visibility', 'visible');
        document.dispatchEvent(new CustomEvent('wsv2:nowcast-legend', { detail: { id: 'hail', spec: {
            title: 'Grandine', unit: 'prob.',
            steps: [
                { color: '#ffd24d', label: '20–50%' },
                { color: '#ff8c1a', label: '50–80%' },
                { color: '#e03131', label: '≥80%' },
            ],
        } } }));
    } else {
        clearInterval(state.timer);
        state.timer = null;
        if (state.map.getLayer(LYR)) state.map.setLayoutProperty(LYR, 'visibility', 'none');
        if (state.popup) { state.popup.remove(); state.popup = null; }
        document.dispatchEvent(new CustomEvent('wsv2:nowcast-legend', { detail: { id: 'hail', spec: null } }));
    }
}
